import { Tooltip } from '@creditornot/cb-popover';
import { Tag } from '@creditornot/cb-tag';
import {
  DelistingReason,
  ListingReason,
  PromotionRecommendationReason,
} from 'common/api-types/recommendations';
import { Stack } from 'common/components/cookbook/Stack';
import { TranslatedReasons } from 'features/selection-recommendations/common/RecommendationReasons/TranslatedReasons';

type Props = {
  reasons: DelistingReason[] | PromotionRecommendationReason[] | ListingReason[];
};

export const RecommendationReasons = ({ reasons }: Props) => {
  if (reasons.length === 0) {
    return null;
  }

  const [visibleReason, ...otherReasons] = reasons;

  return (
    <Stack direction="row" gap="narrowSmall" data-test-id="selection-recommendation-reasons">
      <Tag key={visibleReason} size="small" variant="outlineBlack">
        <TranslatedReasons reason={visibleReason} />
      </Tag>

      {otherReasons.length > 0 && (
        <Tooltip
          content={otherReasons.map((reason) => (
            <div key={reason}>
              <TranslatedReasons reason={reason} />
            </div>
          ))}
        >
          <Tag variant="outlineBlack" size="small">
            + {otherReasons.length}
          </Tag>
        </Tooltip>
      )}
    </Stack>
  );
};
